import React, {FunctionComponent} from "react";
import styles from "./overlay.module.css";
import {HostElementRefProp} from "../HostElementRefProp";

const DEFAULT_OPACITY = 0.88;

interface OverlayProps {
    opacity?: number;
    zIndex?: number;
    onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
}

export const Overlay: FunctionComponent<OverlayProps & HostElementRefProp> = (props) => {
    const opacity = typeof(props.opacity) === "undefined"
        ? DEFAULT_OPACITY
        : props.opacity;

    return (
        <div className={styles.overlay} style={{ backgroundColor: `rgba(12, 15, 26, ${opacity})`, zIndex: props.zIndex }} onClick={props.onClick} ref={props.hostElementRef}>
            {props.children}
        </div>
    );
};